import { Box } from "@mui/material";
export const WorkforceStepContainer = ({ steps, activeStep }) => {
  if (!steps || steps.length === 0) return null;
  const current = steps[activeStep];

  return (
    <Box
      key={activeStep}
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {current?.component || null}
    </Box>
  );
};
